"use client";

import { c as _c } from "react/compiler-runtime";
import { IconArrowBoxLeft } from "central-icons/IconArrowBoxLeft";
import { IconBookmark } from "central-icons/IconBookmark";
import Link from "next/link";
import { useAuth } from "@/components/auth/auth-provider";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
export function UserMenu() {
  const $ = _c(19);
  const {
    user,
    isLoading,
    signOut
  } = useAuth();
  if (isLoading) {
    return null;
  }
  if (!user) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <div className="animate-fade-in"><Button href="/sign-in" size="sm">Sign in</Button></div>;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Button className="select-none rounded-full font-semibold hover:bg-gray-300" size="icon-sm" variant="secondary" />;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = user.email ?? "U";
  let t2;
  if ($[2] !== t1) {
    t2 = t1.charAt(0).toUpperCase();
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <DropdownMenuTrigger aria-label="User menu" render={t0}>{t2}</DropdownMenuTrigger>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== user.email) {
    t4 = <div className="flex h-9 flex-col items-start justify-center gap-1.5 px-2"><p className="font-medium text-sm">{user.email}</p></div>;
    $[6] = user.email;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <DropdownMenuSeparator />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <DropdownMenuItem className="group cursor-pointer text-fg-secondary hover:text-fg" render={<Link href="/saved" />}><IconBookmark aria-hidden="true" className="size-4 text-fg-secondary group-hover:text-fg" mode="raw" />Saved</DropdownMenuItem>;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <IconArrowBoxLeft aria-hidden="true" className="size-4 text-red-500" mode="raw" />;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== signOut) {
    t8 = <DropdownMenuItem className="text-red-500 hover:bg-red-500/10 data-highlighted:bg-red-500/10 data-highlighted:text-red-500 dark:hover:bg-red-500/15 dark:data-highlighted:bg-red-500/15" onClick={signOut}>{t7}Sign out</DropdownMenuItem>;
    $[11] = signOut;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t4 || $[14] !== t8) {
    t9 = <DropdownMenuContent align="end" className="w-56 origin-top-right">{t4}{t5}{t6}{t8}</DropdownMenuContent>;
    $[13] = t4;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t3 || $[17] !== t9) {
    t10 = <div className="animate-fade-in"><DropdownMenu>{t3}{t9}</DropdownMenu></div>;
    $[16] = t3;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
}